
import {
    LOGIN_ACTION_TYPE,
    LOGOUT_ACTION_TYPE,
    CREATE_ACCOUNT_ACTION_TYPE
} from '../sagas/auth';

const initialState = {
    data: null,
    loading: false,
    loginFailed: false,
    loginError: null,
    createAccountFailed: false
};

export default function app(state = initialState, action) {
    switch (action.type) {
        case CREATE_ACCOUNT_ACTION_TYPE.DEFAULT:
        case LOGIN_ACTION_TYPE.DEFAULT:
            return {
                ...state,
                data: null,
                loading: true,
                loginFailed: false,
                loginError: null,
                createAccountFailed: false
            };

        case CREATE_ACCOUNT_ACTION_TYPE.SUCCESS:
        case LOGIN_ACTION_TYPE.SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data
            };

        case CREATE_ACCOUNT_ACTION_TYPE.FAILED:
            return {
                ...state,
                data: null,
                loading: false,
                createAccountFailed: true
            };

        case LOGIN_ACTION_TYPE.FAILED:
            return {
                ...state,
                data: null,
                loading: false,
                loginFailed: true,
                loginError: action.error
            };

        case LOGOUT_ACTION_TYPE.SUCCESS:
            return {
                ...initialState
            };

        default:
            return state
    }
}
